import script from "./ProvisionConfirm.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProvisionConfirm.vue?vue&type=script&lang=ts&setup=true"

import "./ProvisionConfirm.vue?vue&type=style&index=0&id=499e5046&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-499e5046"]])

export default __exports__